import { render, staticRenderFns } from "./FormulateTextNumber.vue?vue&type=template&id=3e849420&"
import script from "./FormulateTextNumber.vue?vue&type=script&lang=js&"
export * from "./FormulateTextNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e849420')) {
      api.createRecord('3e849420', component.options)
    } else {
      api.reload('3e849420', component.options)
    }
    module.hot.accept("./FormulateTextNumber.vue?vue&type=template&id=3e849420&", function () {
      api.rerender('3e849420', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/formulate/text-number/FormulateTextNumber.vue"
export default component.exports